import { useEffect } from 'react';

import { LoadingSpinner } from '../LoadingSpinner/LoadingSpinner';

/**
 * Sends a legacy URL that now lives in sampark-new to its new home. sampark-new is a
 * separate bundle mounted at /app/** on the same origin, so this must be a full page
 * load rather than a react-router transition (see RedirectToNewLogin).
 *
 * `replace` keeps the dead legacy entry out of history so Back does not bounce here.
 */
export const RedirectToNewApp = ({ to }: { to: string }) => {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);

  return <LoadingSpinner />;
};
